import { render, staticRenderFns } from "./pccourses.vue?vue&type=template&id=58b2cf9e"
import script from "./pccourses.vue?vue&type=script&lang=js"
export * from "./pccourses.vue?vue&type=script&lang=js"
import style0 from "./pccourses.vue?vue&type=style&index=0&id=58b2cf9e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports